import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from 'src/app/_core/_services/api.service';

@Injectable({
  providedIn: 'root'
})
export class TenantConfigService {
  constructor(private api: ApiService) {}

  getTenantConfig(tenantId: number) {
    return this.api.getAPI(`tenants/config/${tenantId}`).pipe(
      map((res: any) => {
        return res.body.config;
      })
    );
  }

  storeTenantConfigToLocalStorage(config: any) {
    localStorage.setItem(`tenant-config`, JSON.stringify(config));
  }

  retrieveTenantConfigFromLocalStorage() {
    const config = localStorage.getItem(`tenant-config`);
    if (config) {
      return JSON.parse(config);
    }
    return null;
  }

  // updateTenantConfig(config: any) {
  //   return this.api.putAPI('tenant-config', config).pipe(
  //     map((data: any) => {
  //       return data.body;
  //     })
  //   );
  // }
}
